import i18n from '@/i18n';
import dayjs from 'dayjs';

const t = i18n.t.bind(i18n);

/** 帮我改成函数, 传入EN_US| ZH_CN,返回不同的 text 文本  */
export const getPresetDateRange = (initStartTime?: dayjs.ConfigType) => {
  const shortcuts = [
    {
      key: 'last10Minutes',
      text: t('utils:last.minute-plural', { count: 10 }),
      value: () => [dayjs().subtract(10, 'minute'), dayjs()],
      timeSpan: 10 * 60,
    },
    {
      key: 'last20Minutes',
      text: t('utils:last.minute-plural', { count: 20 }),
      value: () => [dayjs().subtract(20, 'minute'), dayjs()],
      timeSpan: 20 * 60,
    },
    {
      key: 'last30Minutes',
      text: t('utils:last.minute-plural', { count: 30 }),
      value: () => [dayjs().subtract(30, 'minute'), dayjs()],
      timeSpan: 30 * 60,
    },
    {
      key: 'last2Hours',
      text: t('utils:last.hour-plural', { count: 2 }),
      value: () => [dayjs().subtract(2, 'hour'), dayjs()],
      timeSpan: 2 * 60 * 60,
    },
    {
      key: 'last5Hours',
      text: t('utils:last.hour-plural', { count: 5 }),
      value: () => [dayjs().subtract(5, 'hour'), dayjs()],
      timeSpan: 5 * 60 * 60,
    },
    {
      key: 'last12Hours',
      text: t('utils:last.hour-plural', { count: 12 }),
      value: () => [dayjs().subtract(12, 'hour'), dayjs()],
      timeSpan: 12 * 60 * 60,
    },
    {
      key: 'last1Day',
      text: t('utils:last.day', { count: 1 }),
      value: () => [dayjs().subtract(1, 'day'), dayjs()],
      timeSpan: 1 * 24 * 60 * 60,
    },
    {
      key: 'last2Days',
      text: t('utils:last.day-plural', { count: 2 }),
      value: () => [dayjs().subtract(2, 'day'), dayjs()],
      timeSpan: 2 * 24 * 60 * 60,
    },
    {
      key: 'last3Days',
      text: t('utils:last.day-plural', { count: 3 }),
      value: () => [dayjs().subtract(3, 'day'), dayjs()],
      timeSpan: 3 * 24 * 60 * 60,
    },
    {
      key: 'last7Days',
      text: t('utils:last.day-plural', { count: 7 }),
      value: () => [dayjs().subtract(1, 'week'), dayjs()],
      timeSpan: 7 * 24 * 60 * 60,
    },
  ];

  if (initStartTime) {
    // 当前时间减去初始时间
    const timeVal = dayjs().unix() - dayjs(initStartTime).unix();
    // 过滤掉大于当前时间的时间范围
    const filteredShortcuts = shortcuts.filter((item) => {
      return timeVal >= item.timeSpan;
    });

    return filteredShortcuts;
  }

  return shortcuts;
};

export const getPresetDate = (initStartTime?: dayjs.ConfigType) => {
  const shortcuts = [
    {
      key: 'last12Hours',
      text: t('utils:last.hour-plural', { count: 12 }),
      value: () => [dayjs().subtract(12, 'hour'), dayjs()],
      timeSpan: 12 * 60 * 60,
    },
    {
      key: 'last1Day',
      text: t('utils:last.day', { count: 1 }),
      value: () => [dayjs().subtract(1, 'day'), dayjs()],
      timeSpan: 1 * 24 * 60 * 60,
    },
    {
      key: 'last2Days',
      text: t('utils:last.day-plural', { count: 2 }),
      value: () => [dayjs().subtract(2, 'day'), dayjs()],
      timeSpan: 2 * 24 * 60 * 60,
    },
    {
      key: 'last3Days',
      text: t('utils:last.day-plural', { count: 3 }),
      value: () => [dayjs().subtract(3, 'day'), dayjs()],
      timeSpan: 3 * 24 * 60 * 60,
    },
    {
      key: 'last7Days',
      text: t('utils:last.day-plural', { count: 7 }),
      value: () => [dayjs().subtract(1, 'week'), dayjs()],
      timeSpan: 7 * 24 * 60 * 60,
    },
    {
      key: 'last30Days',
      text: t('utils:last.day-plural', { count: 30 }),
      value: () => [dayjs().subtract(30, 'day'), dayjs()],
      timeSpan: 30 * 24 * 60 * 60,
    },
    {
      key: 'last90Days',
      text: t('utils:last.day-plural', { count: 90 }),
      value: () => [dayjs().subtract(90, 'day'), dayjs()],
      timeSpan: 90 * 24 * 60 * 60,
    },
    {
      key: 'last180Days',
      text: t('utils:last.day-plural', { count: 180 }),
      value: () => [dayjs().subtract(180, 'day'), dayjs()],
      timeSpan: 180 * 24 * 60 * 60,
    },
    {
      key: 'last365Days',
      text: t('utils:last.day-plural', { count: 365 }),
      value: () => [dayjs().subtract(365, 'day'), dayjs()],
      timeSpan: 365 * 24 * 60 * 60,
    },
  ];

  if (initStartTime) {
    // 当前时间减去初始时间
    const timeVal = dayjs().unix() - dayjs(initStartTime).unix();
    // 过滤掉大于当前时间的时间范围
    const filteredShortcuts = shortcuts.filter((item) => {
      return timeVal >= item.timeSpan;
    });

    return filteredShortcuts;
  }

  return shortcuts;
};
